import React, { Fragment, Component } from 'react';
import { withRouter } from 'react-router';
import { withSnackbar } from 'notistack';
import moment from 'moment';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, CircularProgress, Tooltip, IconButton, Drawer } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { LabelValueCard, RevisionHistory, PageLoader, CustomChip, CustomDropzone, PreviewDocsModal, DeletePopUp } from '../../../../shared_elements';
import { fieldDateFormat, backendDateFormat, displayDateFormatShort } from '../../../../constants';
import { checkApiStatus, capitalizeFirstLetter, getLocalStorageInfo, checkPermission } from '../../../../utils_v2';
import { fieldValidation, dateRangeValidation } from '../../../../utils_v2/formValidation';
import { addEditEolObligationApi, getEolObligationApi } from '../apiServices';
import { errorCode, addEolObligation } from '../';
import { avationPlcInstance, titanInstance, mtInstance, leshaBankInstance } from '../../../../shared_elements/components';
import { addAttachmentApi, deleteAttachmentApi } from '../../../../shared_elements/apiServices';
class EolObligationCRU extends Component{
  constructor(props){
    super(props);
    this.state = {
      modal:false,
      formSubmitLoader:false,
      pageLoader: false,
      mode:'',
      eolObligation:{},
      error:{},
      previewDocs: '',
      deleteAttachmentModal: false, 
      attachedDoc:[],
      deleteItem : {}
    }
    this.addEditEolObligationApi = addEditEolObligationApi.bind(this);
    this.getEolObligationApi = getEolObligationApi.bind(this);
  }
  onFieldChange = (event, keyParam, data) => {
    this.setState(prevState => ({
      ...prevState,
      eolObligation: {
        ...prevState.eolObligation,
        [keyParam]:data
      }
    }))
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]:message
      }
    }))
  }
  getDeleteResponse = () => {
    const { eolObligation, deleteItem } = this.state
    const updatedAttachments = eolObligation?.attachments?.filter(
      attachment => attachment.uuid !== deleteItem?.uuid
    );
    this.setState(prevState => ({
      ...prevState,
      eolObligation: {
        ...prevState.eolObligation,
        attachments: updatedAttachments
      }
    }))
    this.props.getResponseBack()
  }
  toggleFnc = (key,status)=>{
    this.setState({[key] : status})
  }
  addEditEolObligationFn = () => {
    const { eolObligation } = this.state;
    let validationInputs = {
      reserve_account:errorCode['event'][fieldValidation({...errorCode['eventObj'], fieldval: eolObligation.reserve_account })],
    };
    if(Object.keys(validationInputs).every((k) => { return validationInputs[k] === ''})){
      if (this.state.attachedDoc?.length+eolObligation?.attachments?.length>50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return; 
      }
      let payload = Object.assign({}, eolObligation);
      payload = {
        ...payload,
        reserve_account: eolObligation.reserve_account
      }
      this.addEditEolObligationApi(this.props,payload)
      .then(response => {
        if(checkApiStatus(response)){
          if (this.state.attachedDoc?.length > 0) {
            addAttachmentApi(response?.data, this.props, this.state.attachedDoc, "25", this.toggleFnc);
          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            this.props.getResponseBack();
          }
          this.setState({modal:false, mode:'', eolObligation:{}, error:{}});
        }else{
          this.props.enqueueSnackbar(response.data.message, {variant: 'error', anchorOrigin:{vertical: 'top',horizontal: 'right'}});
        }
      })
    }else{
      this.setState({error:validationInputs});
    }
  }
  render() {
    const { modal, mode, formSubmitLoader, eolObligation, error, pageLoader } = this.state;
    const { id, m, reserveAccounts, contractInfo } = this.props;
    return(
      <Fragment>
        { pageLoader ? <PageLoader />:null}
        { id ?
          <span onClick={() => this.getEolObligationApi(this.props, id, m)}><Tooltip title="View"><VisibilityIcon color='primary' fontSize='small' style={{cursor:'pointer'}}/></Tooltip></span>:
          contractInfo?.hdlineInfo?.archived_asset ?
          null:
          <Button onClick={() => this.setState({modal:true, eolObligation:addEolObligation, mode:'add'})} variant="contained" color="primary"><AddIcon fontSize='small'/>Add EOL Obligation</Button>
        }
        { modal ?
          <Drawer
            open={modal}
            anchor="right"
            onClose={() => this.setState({modal:false, mode:'', eolObligation:{}, error:{}})}
          >
          <div style={{width:'670px'}} className="drawer-container">
            <div className="drawer-header" alignItems='center'>
              <span className="left-blk">{`${capitalizeFirstLetter(mode)} EOL Obligation`}</span>
              <CloseIcon className="close-icon" onClick={()=> this.setState({modal:false})}/>
              { mode !== 'add' ?
                <ul className="list-inline right-blk">
                  <li className="list-inline-item">
                    <RevisionHistory
                      url='audit/contracts/cteolobligation/'
                      queryParams={{action:1, object_id:id}}
                      buttonType={false}
                    />
                  </li>
                  <li className="list-inline-item">
                    { contractInfo?.hdlineInfo?.archived_asset == false && checkPermission('contracts','eol_obligation', 'U') && mode === 'view' && <span className="cta" onClick={() => this.setState({mode:'edit'})}><EditIcon className="edit-icon"/>Edit</span>}
                    {mode !== 'view' && <span className="cta" onClick={() => this.setState({mode:'view'})}><VisibilityIcon className="view-icon"/>View</span>}
                  </li>
                </ul>:null
              }
            </div>
            <div className="drawer-body" style={{position : "sticky"}}>
              <Grid container spacing={3}>
                { mode == 'view' ?
                  <LabelValueCard md={6} xs={12} label='Lease Option' value={eolObligation?.reserve_account && eolObligation?.reserve_account.name ? eolObligation.reserve_account.name:'--'} /> :
                  <Grid item xs={12} md={12}>
                    <Autocomplete
                      options = {reserveAccounts?.filter(reserve => reserve?.status !== 0)}
                      getOptionLabel={option => option?.name}
                      value={eolObligation?.reserve_account ? eolObligation?.reserve_account:null}
                      id="reserve_account"
                      onChange={(e, value) => {this.onFieldChange(e, 'reserve_account', value ? { id: value?.id, name: value?.name } : null); }}
                      renderInput={params => <TextField required onFocus={(e) => this.updateErrorField('reserve_account', '')} error={error.reserve_account ? true:false} helperText={error.reserve_account?error.reserve_account:''} {...params} label="Event" placeholder="Select Event" margin="normal" fullWidth InputLabelProps={{shrink: true}} />}
                    />
                  </Grid>
                }
                {(titanInstance||avationPlcInstance||mtInstance||leshaBankInstance)?<>
                { mode == 'view' ?
                  <LabelValueCard md={12} label='Excess Refund' value={eolObligation?.excess_refund ? eolObligation.excess_refund:'--'} /> :
                  <Grid item xs={12}>
                    <TextField
                      id="excess_refund"
                      label="Excess Refund"
                      fullWidth
                      margin="normal"
                      onChange={(e, value) => this.onFieldChange(e, 'excess_refund', e.target.value)}
                      value={eolObligation?.excess_refund ? eolObligation?.excess_refund:''}
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>
                }                
                { mode == 'view' ?
                  <LabelValueCard md={12} label='Compensation Time' value={eolObligation.compensation_time ? eolObligation.compensation_time:'--'} /> :
                  <Grid item xs={12}>
                    <TextField
                      id="compensation_time"
                      label="Compensation Time"
                      fullWidth
                      margin="normal"
                      onChange={(e, value) => this.onFieldChange(e, 'compensation_time', e.target.value)}
                      value={eolObligation?.compensation_time ? eolObligation?.compensation_time:''}
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>
                }                
                { mode == 'view' ?
                  <LabelValueCard md={12} label='Compensation Type' value={eolObligation.compensation_type ? eolObligation.compensation_type:'--'} /> :
                  <Grid item xs={12}>
                    <TextField
                      id="compensation_type"
                      label="Compensation Type"
                      fullWidth
                      margin="normal"
                      multiline
                      onChange={(e, value) => this.onFieldChange(e, 'compensation_type', e.target.value)}
                      value={eolObligation?.compensation_type ? eolObligation?.compensation_type:''}
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>
                }
                { mode == 'view' ?
                  <LabelValueCard md={12} label='Compensation Base' value={eolObligation.compensation_base ? eolObligation.compensation_base:'--'} /> :
                  <Grid item xs={12}>
                    <TextField
                      id="compensation_base"
                      label="Compensation Base"
                      fullWidth
                      margin="normal"
                      onChange={(e, value) => this.onFieldChange(e, 'compensation_base', e.target.value)}
                      value={eolObligation?.compensation_base ? eolObligation?.compensation_base:''}
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>
                }</>:null}
                { mode == 'view' ?
                  <LabelValueCard md={12} label='Remarks' value={eolObligation.remarks ? ( <span dangerouslySetInnerHTML={{ __html: eolObligation.remarks.replace(/\n/g, '<br />')}}/>):'--'} /> :
                  <Grid item xs={12}>
                    <TextField
                      id="remarks"
                      label="Remarks"
                      fullWidth
                      margin="normal"
                      multiline
                      onChange={(e, value) => this.onFieldChange(e, 'remarks', e.target.value)}
                      rows="6"
                      value={eolObligation.remarks ? eolObligation.remarks:''}
                      InputLabelProps={{shrink: true}}
                    />
                  </Grid>
                }
                  {mode === 'view' ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s)  [Count: {eolObligation?.attachments?.length}]</p>
                      {eolObligation?.attachments?.length ? eolObligation?.attachments && eolObligation?.attachments.map((file, index) => (
                        <CustomChip
                          style={{ marginRight: '4px', marginTop: '7px'}}
                          title={file.name}
                          index={index}
                          label={file.name.substring(0, 14) + '...'}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation();  this.setState({ previewDocs: file }) }}
                        />
                      )) : '--'}
                    </div>
                    :
                    (
                      <Grid item xs={12} style={{ marginBottom: '5px' }} className='drag-drop'>
                        <p style={{ fontSize: '13px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular", marginLeft: '8px' }}>Attachment(s)</p>
                        <CustomDropzone
                          onChange={(files) => this.setState({ attachedDoc: files })}
                          componentData={eolObligation}
                          attachedDoc = {this.state.attachedDoc}
                          isnote={true}
                          note = {`'PRSV severity', 'PRSV severity table', 'de-rate', 'de-rate table', 'Lessor contribution language', 'Lease agreement'`}
                        >
                        </CustomDropzone>
                        {eolObligation?.attachments && eolObligation?.attachments.map((file, index) => (
                          <CustomChip
                            style={{ marginRight: '4px', marginTop: '7px'}}
                            title={file.name}
                            index={index}
                            label={file.name.substring(0, 14) + '...'}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file })}}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteAttachmentModal: true, deleteItem: file }); }}
                          />
                        ))}
                      </Grid>)}
              </Grid>
            </div>
            <div className="drawer-footer">
              { mode !== 'view' ?
                <Button onClick={this.addEditEolObligationFn} color="primary" variant="contained" disabled={formSubmitLoader}>
                  { formSubmitLoader ? <CircularProgress color="#ffffff" size={24} />:'Save Changes' }
                </Button>:null
              }
              <Button onClick={() => this.setState({modal:false, mode:'', eolObligation:{}, error:{}})} color="primary" style={mode == 'view' ? {marginLeft:'auto', paddingLeft:'0px'}:{marginLeft:'8px'}}>Cancel</Button>
            </div>
          </div>
          </Drawer>:null
        }

      {
        this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs}  toggleModalFn={() => this.setState({ previewDocs: '' })}/> : null
      }
      {this.state.deleteAttachmentModal ?
        <DeletePopUp
          modal={this.state.deleteAttachmentModal}
          toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
          title="Delete Attachment"
          content={<h4>Are you sure you want to delete?</h4>}
        deleteRecordFn={() => deleteAttachmentApi(this.state.deleteItem,this.toggleFnc,this.getDeleteResponse)}
        /> : null
      }
      </Fragment>
    )
  }
}
export default withRouter(withSnackbar(EolObligationCRU));
